/** This export is automatically generated */
export const gitHash = 'f441cb93';
